import UserOutline from './UserOutline'

export default UserOutline
